'use client';

import React, { useEffect, useRef, useState } from 'react';
import s from './BookmarkDropdown.module.scss';
import Icon from '../Icon';
import Popover from '../Popover/Popover';
import { t } from '../../i18n';
import Bookmark from '../Bookmark/Bookmark';
import classNames from 'classnames';
import { useBookmarkContext } from '../../utils/bookmark-provider';

const BookmarkDropdown = () => {
    const { bookmarkedPages, lastAddedUrl } = useBookmarkContext();
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const popoverRef = useRef(null);

    const togglePopover = () => {
        setIsPopoverOpen(!isPopoverOpen);
    };

    const handleClickOutside = (event) => {
        if (popoverRef.current && !popoverRef.current.contains(event.target)) {
            setIsPopoverOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className={s.Root}>
            <Popover
                onClick={togglePopover}
                isPopoverOpen={isPopoverOpen}
                popoverRef={popoverRef}
                minWidth="238px"
                content={
                    <div className={s.Content}>
                        <div className={s.Header}>
                            <span className={s.Title}>
                                Favorite pages
                                <span className={s.TitleCount}>
                                    ({bookmarkedPages.length})
                                </span>
                            </span>
                        </div>
                        {bookmarkedPages.length === 0 ? (
                            <div className={s.NoResults}>
                                <span className={s.NoResultsTitle}>
                                    {t('general.noBookmarks')}
                                </span>
                                <span className={s.NoResultsText}>
                                    {t('general.noBookmarksText')}
                                </span>
                            </div>
                        ) : (
                            <ul className={s.List}>
                                {bookmarkedPages.map((bookmark, index) => (
                                    <li className={s.Item} key={bookmark.url}>
                                        <a
                                            className={s.Link}
                                            href={bookmark.url}>
                                            <span className={s.Text}>
                                                {bookmark.title}
                                            </span>
                                            {bookmark?.categories?.length >
                                                0 && (
                                                <div
                                                    className={classNames(
                                                        s.CategoryList,
                                                        {
                                                            [s.HasMultiple]:
                                                                bookmark
                                                                    .categories
                                                                    .length > 1,
                                                        }
                                                    )}>
                                                    {bookmark.categories.map(
                                                        (category, index) => (
                                                            <div
                                                                key={index}
                                                                className={
                                                                    s.Category
                                                                }>
                                                                {category}
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            )}
                                        </a>
                                        <div className={s.BookmarkTabIcon}>
                                            <Bookmark
                                                url={bookmark.url}
                                                isSmall={true}
                                                modifiers={['Grey']}
                                                categories={bookmark.categories}
                                                alternativeTitle={
                                                    bookmark.title
                                                }
                                                noAnimation={true}
                                            />
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                }>
                <div className={s.Button}>
                    <Icon
                        name={lastAddedUrl ? 'BookmarkCheck' : 'BookmarkEmpty'}
                    />
                    <span className={s.Label}>
                        {lastAddedUrl
                            ? t('general.added')
                            : t('general.bookmark')}
                    </span>
                </div>
            </Popover>
        </div>
    );
};

export default BookmarkDropdown;
